import React, { useEffect, useState, useRef } from 'react';
import { LinearProgress } from '@jpmuitk/progress';
import { ColumnLayout } from "@jpmuitk/column-layout";
import { useTranslation } from 'react-i18next';
import { Card } from '@jpmuitk/card';
import { notifyRedirectSignal } from '../../redux/clientActions';

export default function ConfirmationScreen({ redirectUrl, setIsRedirecting, outcome, accessToken, sessionToken }) {

  const { t, i18n } = useTranslation();
  const countdown = 5;
  const [timeLeft, setTimeLeft] = useState(countdown);
  const hasRedirected = useRef(false);
  const hasSignaledRef = useRef(false);
  const timerIdRef = useRef(null);

  const LinearShowNoInfo = () => <LinearProgress showInfo={false}
    value={formatCountdown(timeLeft)}
    role={"progressbar"}
    aria-label={"progress"}
    size={"medium"} />;

  const formatCountdown = (timeLeft) => {
    return ((countdown - timeLeft) / countdown) * 100;
  }

  useEffect(() => {
    console.log('[ConfirmationScreen] Starting countdown interval, timeLeft:', countdown);
    timerIdRef.current = setInterval(() => {
      setTimeLeft(t => {
        console.log('[ConfirmationScreen] Interval tick - timeLeft:', t - 1);
        if (t <= 1) {
          console.log('[ConfirmationScreen] Countdown complete, clearing interval');
          clearInterval(timerIdRef.current);
          timerIdRef.current = null;
        }
        return t - 1;
      });
    }, 1000);

    return () => {
      if (timerIdRef.current) {
        console.log('[ConfirmationScreen] Cleanup: clearing interval');
        clearInterval(timerIdRef.current);
        timerIdRef.current = null;
      }
    };
  }, []);

  const signalRedirect = async () => {
    if (hasSignaledRef.current) {
      return;
    }
    hasSignaledRef.current = true;
    if (!accessToken || !sessionToken) {
      return;
    }
    try {
      await Promise.race([
        notifyRedirectSignal(accessToken, sessionToken, outcome),
        new Promise((resolve) => setTimeout(resolve, 1500)),
      ]);
    } catch (error) {
      console.error('[ConfirmationScreen] redirect signal failed (fail-open):', error);
    }
  };

  useEffect(() => {
    if (timeLeft <= 0 && !hasRedirected.current) {
      console.log('[ConfirmationScreen] timeLeft reached 0, redirecting to:', redirectUrl);
      hasRedirected.current = true;
      if (timerIdRef.current) {
        console.log('[ConfirmationScreen] Clearing interval before redirect');
        clearInterval(timerIdRef.current);
        timerIdRef.current = null;
      }
      setIsRedirecting?.(true);
      signalRedirect().finally(() => {
        window.location.replace(redirectUrl);
      });
    }
  }, [timeLeft, redirectUrl, setIsRedirecting]);

  return (
    <Card style={{ width: '100%', maxWidth: 850, minHeight: 450, display: 'flex', justifyContent: 'center', alignItems: 'center' }} data-testid="confirmation-card">
      <ColumnLayout container={true} spacing={3} justify="center" alignItems="center" style={{ textAlign: 'center' }}>
        <ColumnLayout item xs={12}>
          <h2 style={{ margin: 0, padding: 0 }}>{t('submitted')}</h2>
        </ColumnLayout>
        <ColumnLayout item xs={12}>
          <p style={{ margin: 0, padding: 0, fontSize: 14 }}>{t('success_redirect')}</p>
        </ColumnLayout>
        <ColumnLayout item xs={12}>
          <LinearShowNoInfo />
        </ColumnLayout>
      </ColumnLayout>
    </Card>
  );
}
